/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `class` - Klasa
 * * `school` - Szkoła
 */
export type BulkScopeKindEnum = typeof BulkScopeKindEnum[keyof typeof BulkScopeKindEnum];


export const BulkScopeKindEnum = {
  class: 'class',
  school: 'school',
} as const;
